import Dashboard from "@/components/dashboard";
import { sessionQueryOptions } from "@/lib/query-options";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const dashboardSearchSchema = z.object({
  dateRange: z
    .enum(["this-month", "this-year", "all-time"])
    .optional()
    .default("this-month"),
});

type DashboardSearch = z.infer<typeof dashboardSearchSchema>;

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/team/$teamId/dashboard",
)({
  component: DepartmentDashboard,
  validateSearch: dashboardSearchSchema,
  beforeLoad: async ({ context, params }) => {
    const queryClient = context.queryClient;
    const { companyId, teamId } = params;

    try {
      const session = await queryClient.ensureQueryData(sessionQueryOptions);

      // Check if user has access to this company
      const hasCompanyAccess = session?.user.companies?.some(
        (c) => c.id === companyId,
      );

      // Check if user has access to this department (as any role)
      const hasDepartmentAccess = session?.user.departments?.some(
        (d) => d.id === teamId,
      );

      if (!hasCompanyAccess && !hasDepartmentAccess) {
        throw redirect({
          to: "/",
          replace: true,
        });
      }
    } catch (error) {
      console.error("Failed to fetch session or check permissions:", error);
      throw redirect({
        to: "/login",
        replace: true,
      });
    }
  },
});

function DepartmentDashboard() {
  const { teamId } = Route.useParams();

  return <Dashboard mode="department" departmentId={teamId} />;
}
